export const ClientDetailsViewTabId = {
	BILLING_DETAILS: "billing-Details",
	CONTACTS: "contacts",
	INVOICE_RECIPIENTS: "invoice-recipients",
	PROJECTS: "projects",
	QUOTAS: "quotas",
} as const;

export type ClientDetailsViewTabId = typeof ClientDetailsViewTabId[keyof typeof ClientDetailsViewTabId];

export const CLIENT_DETAILS_VIEW_TAB_ID_PARAM_NAME = "view";